module.exports = __webpack_public_path__ + "static/media/127-sri-lanka.e3a09675.svg";